import { logoutUser } from '../repositories/auth.actions';
import { dispatch } from '@ngneat/effects';

/**
 * Use this function to log the User out of both SSO and TID
 */
export const logout = () => {
  dispatch(logoutUser());
};
